/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Lustrace_Status_ErrorInputs */

const cs_property_lustrace_status_error = /** @type {(inputs: Property_Lustrace_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba`)
};

const en_property_lustrace_status_error = /** @type {(inputs: Property_Lustrace_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Property_Lustrace_Status_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_lustrace_status_error = /** @type {((inputs?: Property_Lustrace_Status_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Lustrace_Status_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_lustrace_status_error(inputs)
	return cs_property_lustrace_status_error(inputs)
});